<template>
  <div class="BoxContent">
    <div class="boxOne">
      <svg-btn class="icon" icon-class="icon-short-no"></svg-btn>
      <span class="font1">{{ $t('model.mtest4') }}</span>
      <!-- <div class="bottomBox">
        <div class="left">
          <span class="font2">{{ $t('model.mtest5') }}</span>
          <span class="font3" @click="goHelp(98)">{{
            $t('model.mtest8')
          }}</span>
        </div>
        <div class="right">
          <span class="font2">{{ $t('model.mtest6') }}</span>
          <span class="font3" @click="goHelp(0)">{{ $t('model.mtest9') }}</span>
        </div>
      </div> -->
    </div>
    <!-- <div class="boxTwo">
      <el-carousel :interval="3000" trigger="click" arrow="never">
        <el-carousel-item
          v-for="(item, index) in $store.state.banner"
          :key="index"
        >
          <img :src="item.img" class="img" @click="open(item.url)" />
        </el-carousel-item>
      </el-carousel>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    open(url) {
      window.open(url, '_href')
    },
    goHelp(type) {
      let url
      if (type == 0) {
        url = this.$glb.feemooUrl + '/help'
      } else {
        url = this.$glb.feemooUrl + '/askdetail/98'
      }
      window.open(url, '_href')
    },
  },
}
</script>

<style lang="scss" scoped>
.BoxContent {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: calc(100vh - 64px);
  .boxOne {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: #ffffff;
    border-radius: 32px;
    // margin-top: 32px;
    width: 576px;
    min-height: 202px;
    padding: 64px 36px;
    .icon {
      width: 36px;
      height: 36px;
    }
    .font1 {
      font-weight: 500;
      font-size: 18px;
      color: #2c2c2c;
      line-height: 26px;
      margin-top: 12px;
      word-break: break-all;
    }
    .bottomBox {
      margin-top: 8px;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      .font2 {
        font-weight: 400;
        font-size: 13px;
        color: #8a8b92;
        line-height: 18px;
      }
      .font3 {
        cursor: pointer;
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
        color: #f67942 !important;
      }
    }
  }
  .boxTwo {
    width: 576px;
    height: 324px;
    min-height: 324px;
    max-height: 324px;
    background: #ffffff;
    border-radius: 32px;
    ::v-deep .el-carousel {
      height: 100%;
      border-radius: 32px;
      .el-carousel__container {
        height: 100% !important;
      }
      .el-carousel__indicator {
        padding: 0;
        margin-right: 4px;
        margin-bottom: 24px;
      }
      .is-active {
        .el-carousel__button {
          width: 20px !important;
          opacity: 1 !important;
        }
      }
      .el-carousel__button {
        width: 8px;
        height: 8px;
        background: #ffffff;
        border-radius: 5px;
        opacity: 0.6;
      }
    }
    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 32px;
    }
  }
}
</style>
